export default __webpack_public_path__ + "static/media/iconeUserMaior.22e1ab65.png";